import React from "react";

//importing fuc
import { closePop } from "../utilities/helper";

const PopContainer = (props) => {
  return (
    <div className="pop-up" id="pop" onClick={closePop}>
      <div className="pop-up__content" id="content">
        {props.children}
      </div>
    </div>
  );
};
export default PopContainer;
